export default {
  mode: 'dark',
  common: {
    black: '#000',
    white: '#FFF'
  },
  primary: {
    main: '#6B8CFF', // brighter version for dark bg
    light: '#616161',
    dark: '#3D5AD6',
    contrastText: '#fff',
    background: '#121212'
  },
  secondary: {
    main: '#A6A6A6',
    light: '#D9D9D9',
    dark: '#595959',
    contrastText: '#000'
  },
  error: {
    main: '#FF6B6B',
    light: '#FF9999',
    dark: '#B22222',
    contrastText: '#fff'
  },
  warning: {
    main: '#FFB84D',
    light: '#d19d3e',
    dark: '#CC8A1A',
    contrastText: '#000'
  },
  info: {
    main: '#4DB8FF',
    light: '#80D4FF',
    dark: '#1A75B3',
    contrastText: '#fff'
  },
  success: {
    main: '#57C757',
    light: '#8DE28D',
    dark: '#2E7D32',
    contrastText: '#fff'
  },
  accent: {
    main: '#FF884D',
    light: '#FFAA80',
    dark: '#CC5C1A',
    contrastText: '#fff'
  },
  grey: {
    50: '#1A1A1A',
    100: '#E5E5E5',
    200: '#F2F2F2',
    300: '#4D4D4D',
    400: '#666666',
    500: '#808080',
    600: '#A6A6A6',
    650: '#BFBFBF',
    700: '#D9D9D9',
    900: '#E5E5E5',
    1000: '#F2F2F2'
  },
  action: {
    active: '#4DB8FF',
    hover: 'rgba(255, 255, 255, 0.1)',
    hoverOpacity: 0.08
  },
  login: {
    background: '#121212'
  },
  booking: {
    checkBox: '#4E9BF3',
    link: '#69B3FF',
    button: '#2A6BCE',
    background: '#1C1C1C',
    dialogFooter: '#1C1C1C',
    info: '#262626',
    header: '#E0E0E0',
    field: '#3A4B6D',
    backgroundField: '#2A2A2A',
    confirmation: '#1E3D1E',
    confirmationText: '#6EE06E',
    borderBox: '#333333',
    lightSubHeader: '#A6A6A6',
    profileButton: '#5DA7F0',
    total: '#333333',
    list: '#121212'
  },
  profile: {
    buttonGrey: '#666666'
  }
};
